module.exports = __webpack_public_path__ + "img/logo.0ac7d337.png";